import { useState, useEffect, memo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import AutoAppLogoClean from '../assets/AutoappLogoClean.svg';
import { useAppTheme } from '../context/theme.context';

/**
 * Pantalla de carga que muestra el logo inmediatamente
 * y el spinner después de un pequeño delay.
 * Esto evita el "flash" de la pantalla de login al recargar.
 */
const DelayedLoadingScreen = memo(() => {
  const [showSpinner, setShowSpinner] = useState(false);
  const { colors } = useAppTheme();

  useEffect(() => {
    // Solo retrasar el spinner, el logo se muestra inmediatamente
    const timer = setTimeout(() => {
      setShowSpinner(true);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 3,
        backgroundColor: colors.background.page,
      }}
    >
        <img src={AutoAppLogoClean} alt="AutoApp Logo" height="80" width="80" />
        <Box sx={{ height: 40, display: 'flex', alignItems: 'center' }}>
          {showSpinner && (
            <CircularProgress
              size={40}
              sx={{
                color: colors.accent,
                '& .MuiCircularProgress-circle': {
                  strokeLinecap: 'round',
                },
              }}
            />
          )}
        </Box>
    </Box>
  );
});

export default DelayedLoadingScreen;
